import Price from '@components/price/Price'
import Pdf from '@components/display/offer/Pdf'
import WatchMobileShift from '@components/display/offer/WatchMobileShift'
import { captionFor } from '@utils/alt/listAlt'
import useT from '@hooks/useTranslation'

import styles from 'styles/DisplayTitle.module.css'

const TitlePrice = ({ offer, offer: { price = {}, tracking: { deleted } = {}} = {}, nowatch, nopdf }) => {
    const heading = captionFor(offer)
    const naWynajem = useT('pojazd do wynajęcia')
    const naSprzedaz = useT('na sprzedaż')
    const fakturaVAT = useT('faktura VAT')

    const tags = price?.rent
        ? [naWynajem]
        : [naSprzedaz]

    if (price?.price_invoice) tags.push(fakturaVAT)

    return (
        <>
            { !nopdf && !deleted && <><Pdf offer={offer} /><br/><br/></> }

            <div className={styles.wrapper}>
                <div className={styles.headings}>
                    <h1>{heading}<IsDeleted deleted={deleted} /></h1>
                    <h2>{tags.join(', ')}</h2>
                </div>

                { !nowatch && <WatchMobileShift offer={offer} style={{ bottom: -75, right: 0 }} /> }

                <Price {...price} noadditionals />
            </div>
        </>
    )
}

function IsDeleted ({ deleted }) {
    return deleted
        ? <span style={{display:'inline',color:'red'}}> - {useT('SPRZEDANE')}</span>
        : null
}

export default TitlePrice